<div class="tt-o-filter__options-group tt-u-spacing--sm">
  <div class="tt-o-filter__options-group-title" v-html="label"></div>
  <div class="tt-o-filter__options-items">
    <tt-button v-for="filterOption in filterOptions"
               type="toggle"
               class="tt-o-filter__options-item"
               @click="optionClicked(filterOption.option)"
               :class="{'tt-o-button--toggle--is-active': filterOption.isActive}" v-html="filterOption.option.title"></tt-button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/objects/menu/filter-options-group.html